/**
 * 几何关系属性面板注册文件。
 * 注册几何关系面板到 PropertyManager。
 */

import { canShowGeometryRelationsSection, registerPropertyManagerSection } from '@/core';
import GeometryRelationsPanel from '@/components/editor/property-manager/geometry-relations/GeometryRelationsPanel.vue';

/**
 * 注册几何关系属性面板。
 * 仅当草图模式下存在多实体选择时显示。
 */
registerPropertyManagerSection({
  /** 面板唯一标识 */
  id: 'geometry-relations-panel',
  /** 面板组件 */
  component: GeometryRelationsPanel,
  /** 面板标题 */
  title: '属性',
  /** 面板排序优先级 */
  order: 100,
  //------ 几何关系面板动作补齐 开始------
  /** 面板动作按钮；选择态只保留确认，用于清空选择并退出关系面板。 */
  actions: {
    confirm: true,
  },
  /** 确认动作：清空当前选择并退出关系面板。 */
  onConfirm: (context) => {
    context.clearSelection?.();
  },
  //------ 几何关系面板动作补齐 结束------
  /**
   * 面板可见性判定。
   * 仅当草图模式下存在多实体选择时显示。
   * @param context 属性管理器上下文。
   * @returns 面板是否应该显示。
   */
  isApplicable: (context) => {
    return canShowGeometryRelationsSection(context);
  },
});
